import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useContext, useState } from "react";
const ChangeTrackingContext = createContext(undefined);
export const ChangeTrackingProvider = ({ children }) => {
    const [updatedSectionIds, setUpdatedSectionIds] = useState(new Set());
    const markSectionAsUpdated = (sectionId) => {
        setUpdatedSectionIds(prev => new Set([...prev, sectionId]));
    };
    const removeSectionUpdate = (sectionId) => {
        setUpdatedSectionIds(prev => {
            const newSet = new Set(prev);
            newSet.delete(sectionId);
            return newSet;
        });
    };
    const clearSectionTracking = () => {
        setUpdatedSectionIds(new Set());
    };
    const value = {
        updatedSectionIds,
        setUpdatedSectionIds,
        markSectionAsUpdated,
        removeSectionUpdate,
        clearSectionTracking,
    };
    return _jsx(ChangeTrackingContext.Provider, { value: value, children: children });
};
export const useChangeTracking = () => {
    const context = useContext(ChangeTrackingContext);
    if (!context) {
        throw new Error("useChangeTracking must be used within a ChangeTrackingProvider");
    }
    return context;
};
